import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ErrorBoundary } from "./screens/ErrorBoundary";
import "./index.css";

const rootEl = document.getElementById("root");

try {
  // Tell the boot watchdog in index.html that the bundle executed.
  window.__estatebookReady = true;
  createRoot(rootEl).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
  );
} catch (e) {
  rootEl.innerHTML =
    '<div style="max-width:560px;margin:60px auto;padding:24px;font-family:Inter,system-ui,sans-serif;' +
    'color:var(--text-1);background:var(--bg-surface);border:1px solid var(--border-1);border-radius:16px">' +
    '<div style="font-weight:600;font-size:18px;margin-bottom:8px">Estatebook failed to start</div>' +
    '<div style="font-size:14px;line-height:1.6;color:var(--text-2)">' +
    (e && e.message ? e.message : String(e)) +
    "</div></div>";
}
